import React, { FunctionComponent } from 'react'
import { InfluencerCampaigns } from 'Redux/reducers/influencerReducer'
import { useDispatch } from 'react-redux'
import {
  openCampaignDetails,
  getEventById,
} from 'Redux/actions/influencerActions'

import { ListItem } from '../ListItem'
import { TracksListContainer } from './styles'

type TracksListProps = {
  campaigns: InfluencerCampaigns[]
  currentTubKey: string
}

export enum TabKeys {
  new = 'new',
  in_progress = 'in_progress',
  awaiting = 'awaiting',
  completed = 'completed',
  canceled = 'canceled',
}

export const TracksList: FunctionComponent<TracksListProps> = ({
  campaigns,
  currentTubKey,
}) => {
  const dispatch = useDispatch()

  const openDetails = (id: number) => {
    if (currentTubKey === TabKeys.new) {
      dispatch(openCampaignDetails(id))
    } else dispatch(getEventById(id))
  }

  return (
    <TracksListContainer>
      {campaigns?.map(item => (
        <ListItem
          key={item?.id}
          id={item?.id}
          campaign={item}
          onDetailsClick={openDetails}
        />
      ))}
    </TracksListContainer>
  )
}
